import { getBrandCheckUrl, getSiteIcon } from '../utils/brandingConfig';

const LEGACY_CACHE_KEY = 'site_icon';

const getFaviconCacheKey = () => {
  const brandUrl = getBrandCheckUrl();
  return brandUrl ? `site_icon:${brandUrl}` : LEGACY_CACHE_KEY;
};

export function setFavicon(url) {
  if (!url || typeof document === 'undefined') return;

  let link = document.querySelector('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }

  if (link.getAttribute('href') === url) return;

  link.href = url;
  link.type = /\.ico($|\?)/i.test(url) ? 'image/x-icon' : 'image/png';
}

export function applyFaviconFromConfig(configData) {
  const url = configData?.site_icon;
  if (!url) return;

  setFavicon(url);

  try {
    localStorage.setItem(getFaviconCacheKey(), url);
  } catch (_) {
    // ignore quota / private mode
  }
}

export function applyCachedFavicon() {
  try {
    const cacheKey = getFaviconCacheKey();
    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      setFavicon(cached);
      return;
    }
  } catch (_) {
    // ignore
  }

  const fallback = getSiteIcon();
  if (fallback) setFavicon(fallback);
}
